import type { AuthProvider } from './authProvider'
import { LocalAuthProvider } from './authProvider'
import { getSupabaseConfig } from '../supabase/config'
import { SupabaseGoogleAuthProvider } from './supabaseGoogleAuthProvider'
import { getNeonRuntime } from '../neon/runtime'

export function createAuthProvider(): AuthProvider {
  const config = getSupabaseConfig()
  if (config?.backend === 'neon') return getNeonRuntime()?.provider ?? new LocalAuthProvider()
  if (config) return new SupabaseGoogleAuthProvider()
  return new LocalAuthProvider()
}
